(() => {
  const CONFIG_SELECTOR = '[data-trustpilot-product-review-config]';
  const APP_TEMPLATE_ID = '54d39695764ea907c0f34825';
  const MULTISOURCE_TEMPLATE_ID = '577258fb31f02306e4e3aaf9';
  const SUMMARY_READY_EVENT = 'trustpilot:product-summary:ready';
  const APP_WIDGET_SELECTOR = [
    `.shopify-app-block .trustpilot-widget[data-template-id="${APP_TEMPLATE_ID}"]`,
    '.shopify-app-block .trustpilot-widget.trustpilot-multisource-compat',
  ].join(',');

  const readIdentifiers = () => {
    const element = document.querySelector(CONFIG_SELECTOR);
    if (!element) return [];

    try {
      const config = JSON.parse(element.textContent);
      return [...new Set((config.identifiers || []).map(String).map((value) => value.trim()))]
        .filter(Boolean);
    } catch (error) {
      return [];
    }
  };

  const createRatingSummary = () => {
    const summary = document.createElement('button');
    summary.type = 'button';
    summary.className = 'wt-product__title-trustpilot-summary';
    summary.dataset.productTrustpilotSummary = '';
    summary.dataset.productTrustpilotScroll = '';
    summary.hidden = true;

    const stars = document.createElement('span');
    stars.className = 'wt-product__title-trustpilot-stars';
    stars.dataset.productTrustpilotStars = '';
    stars.setAttribute('aria-hidden', 'true');

    for (let starIndex = 1; starIndex <= 5; starIndex += 1) {
      const star = document.createElement('span');
      star.className = 'wt-product__title-trustpilot-star';
      star.dataset.productTrustpilotStar = String(starIndex);
      star.textContent = '\u2605';
      stars.append(star);
    }

    const score = document.createElement('span');
    score.className = 'wt-product__title-trustpilot-score';
    score.dataset.productTrustpilotRating = '';

    const scale = document.createElement('span');
    scale.className = 'wt-product__title-trustpilot-scale';
    scale.dataset.productTrustpilotScale = '';
    scale.textContent = '/ 5';

    const reviews = document.createElement('span');
    reviews.className = 'wt-product__title-trustpilot-reviews';
    reviews.dataset.productTrustpilotReviews = '';
    reviews.hidden = true;

    summary.append(stars, score, scale, reviews);
    return summary;
  };

  const createEmptyState = () => {
    const empty = document.createElement('span');
    empty.className = 'wt-product__title-trustpilot-empty';
    empty.dataset.productTrustpilotEmpty = '';
    empty.hidden = true;
    empty.textContent = 'No reviews yet';
    return empty;
  };

  const ensureRatingSummary = (widget) => {
    const appBlock = widget.closest('.shopify-app-block');
    if (!appBlock) return;

    let changed = false;

    if (!appBlock.hasAttribute('data-product-trustpilot-title')) {
      appBlock.dataset.productTrustpilotTitle = '';
      appBlock.classList.add('wt-product__title-trustpilot');
      changed = true;
    }

    let widgetWrapper = [...appBlock.children].find((child) =>
      child.classList.contains('wt-product__title-trustpilot-widget')
    );

    if (!widgetWrapper) {
      widgetWrapper = document.createElement('div');
      widgetWrapper.className = 'wt-product__title-trustpilot-widget';
      appBlock.insertBefore(widgetWrapper, widget);
      widgetWrapper.append(widget);
      changed = true;
    }

    if (!appBlock.querySelector('[data-product-trustpilot-summary]')) {
      appBlock.append(createRatingSummary());
      changed = true;
    }

    if (!appBlock.querySelector('[data-product-trustpilot-empty]')) {
      appBlock.append(createEmptyState());
      changed = true;
    }

    if (changed) {
      document.dispatchEvent(new CustomEvent(SUMMARY_READY_EVENT));
    }
  };

  const hasMultisourceFrame = (widget, skuList) => {
    if (
      widget.dataset.templateId !== MULTISOURCE_TEMPLATE_ID ||
      widget.dataset.sku !== skuList
    ) {
      return false;
    }

    return [...widget.querySelectorAll('iframe')].some((frame) =>
      frame.src.includes(`/trustboxes/${MULTISOURCE_TEMPLATE_ID}/`)
    );
  };

  const loadMultisourceWidget = (widget, skuList) => {
    if (hasMultisourceFrame(widget, skuList)) return true;

    widget.dataset.templateId = MULTISOURCE_TEMPLATE_ID;
    widget.dataset.sku = skuList;
    widget.classList.add('trustpilot-multisource-compat');
    widget.removeAttribute('data-integration');
    widget.querySelectorAll('iframe').forEach((frame) => frame.remove());

    if (typeof window.Trustpilot?.loadFromElement !== 'function') return false;

    window.Trustpilot.loadFromElement(widget, true);
    return true;
  };

  const applyMultisourceIdentifiers = () => {
    const skuList = readIdentifiers().join(',');
    const widgets = [...document.querySelectorAll(APP_WIDGET_SELECTOR)];
    if (!skuList || !widgets.length) return true;

    widgets.forEach(ensureRatingSummary);
    return widgets.every((widget) => loadMultisourceWidget(widget, skuList));
  };

  let retryTimer;

  const initialise = () => {
    window.clearInterval(retryTimer);

    let attempts = 0;
    const apply = () => {
      attempts += 1;
      if (applyMultisourceIdentifiers() || attempts >= 60) {
        window.clearInterval(retryTimer);
      }
    };

    apply();
    retryTimer = window.setInterval(apply, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', initialise);
})();
